import { Link } from 'react-router-dom';

export const Schedule = () => {
    return (
        <div className="container">
            <h2>Schedule</h2>
            <h3>Our Regatta and Events Schedule.</h3>

            <div className='mt-4'>

                <h2><Link to="/hampton">Hampton Beach Regatta</Link></h2>
                <p>June 20-21</p>

                <h2>
                    <Link to="/sebago">Sebago 1</Link>
                </h2>
                <p>July 17, 18, 19</p>

                <h2>
                    <Link to="/sebago" >Sebago 2</Link>
                </h2>
                <p>August 21, 22, 23</p>
            </div>
        </div>
    );
}

export default Schedule;
